'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('survey-editor', {
      url: '/survey/edit/:id',
      template: '<survey-edit></survey-edit>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/survey/edit/survey-editor.routes.js